import main from './main';
import recruitment from './recruitment';
import errors from './errors';

export default {
  path: '/admin',
  component: () => import('@/admin/layouts/Layout'),
  children: [
    {
      path: '',
      component: () => import('@/admin/layouts/App'),
      children: [
        ...main,
        ...recruitment,
        ...errors,
      ],
    },
  ],
}
